import * as React from 'react';
import { compKey } from './key';
import { Text } from '../../new-libby/core/typography';
import { namespacedClassnames } from '../../common';
export var Profile = function (props) {
    var classNames = namespacedClassnames(compKey, props.className);
    return (React.createElement("div", { className: classNames },
        React.createElement("img", { className: 'profile-pic', src: props.imgUrl }),
        React.createElement("div", { className: 'profile-info' },
            React.createElement(Text, { className: 'profile-title', type: 'hxsm', color: 't20' }, props.title),
            React.createElement("div", { className: 'profile-subtitle' }, props.subtitle))));
};
//# sourceMappingURL=index.js.map